import { ref } from 'vue';

import {
  IFloor,
  IVAV,
} from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

// Async imports for all floors
const getFirstFloor = () =>
  import(
    '@/Core.Service.Domain/Controls/DigitalTwin/MGMOB/API/MGMOB_1st_Floor/floor'
  ).then((module) => module.default);

const getSecondFloor = () =>
  import(
    '@/Core.Service.Domain/Controls/DigitalTwin/MGMOB/API/MGMOB_2nd_Floor/floor'
  ).then((module) => module.default);

const getThirdFloor = () =>
  import(
    '@/Core.Service.Domain/Controls/DigitalTwin/MGMOB/API/MGMOB_3rd_Floor/floor'
  ).then((module) => module.default);

export const dialog = ref<boolean>(false);
export const childTab = ref<number>(0);
export const selectedVAVId = ref<number>();

export const isClickFromCommonArea = ref<boolean>(false);

export const vav = ref<IVAV>({} as IVAV);

// Initialize floors array with placeholders for all floors
export const floors = ref<IFloor[]>([
  {} as IFloor, // Placeholder for FirstFloor
  {} as IFloor, // Placeholder for SecondFloor
  {} as IFloor, // Placeholder for ThirdFloor
]);

// Load all floors asynchronously and update the floors array
Promise.all([getFirstFloor(), getSecondFloor(), getThirdFloor()]).then(
  ([firstFloor, secondFloor, thirdFloor]) => {
    floors.value[0] = { ...firstFloor };
    floors.value[1] = { ...secondFloor };
    floors.value[2] = { ...thirdFloor };
  }
);
